import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axiosInstance  from "../../../utils/axiosConfig";

export const validateSession = createAsyncThunk(
  "userAuthentication/validateSession",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}user/validate-session`, {
        userId: state.userAuthentication.user?.id,
      });
      if (!data) {
        throw new Error("Usuario desconectado");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
